import React from "react";
import moment from "moment";

import { toast } from "react-toastify";

import { Badge, Popover, OverlayTrigger, DropdownButton, MenuItem } from "react-bootstrap";
import Select from "react-select";
import { Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDatabase,
  faBullseye,
  faPlus,
  faTimes,
  faTrash,
  faUser,
  faDesktop,
  faExclamationTriangle,
  faExclamationCircle,
  faUpload
} from "@fortawesome/free-solid-svg-icons";

import awsIcon from "images/logo-aws.svg";
import azureIcon from "images/logo-azure.svg";
import gcpIcon from "images/gcp.svg";

import * as BaseAPI from "api/BaseAPI";

import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { isEnabled } from "utils/featureFlags";

import styles from "./styleView.module.css";

export default class AccountTile extends React.PureComponent {
  state = {
    isCreating: false,
    name: "",
    accountId: "",
    showAnnotations: false,
    createType: "gcp",
    subscriptionID: "",
    regionName: "",
    cloudBaseUrl: "",
    projectId: "",
    gcpRegionName: ""
  };

  handleCreate(name, id) {
    const { handleCreateAWSAccount } = this.props;

    this.setState({ isCreating: false });
    return handleCreateAWSAccount(name, id);
  }

  handleAzureCreate(name, subscriptionID, cloudBaseUrl, regionName) {
    const { handleCreateAzureAccount } = this.props;

    // const runURL =
    //   "https://" +
    //   groupID +
    //   ".azurewebsites.net/api/launchfunc?code=" +
    //   encodeURIComponent(launchCode);
    // AuthURL is no longer required, leaving placeholder in order to minimize backend changes
    // const authURL = runURL;
    const config = {
      subscriptionID,
      regionName,
      cloudBaseUrl
    };
    this.setState({ isCreating: false });
    return handleCreateAzureAccount(name, config);
  }

  handleGCPCreate(name, projectId, regionName) {
    const { handleCreateGCPAccount } = this.props;

    const config = {
      projectId,
      regionName
    };

    this.setState({ isCreating: false });
    return handleCreateGCPAccount(name, config);
  }

  renderMessage(type, index) {
    return (
      <div key={index} className={styles.warnMsg}>
        {type.message}
      </div>
    );
  }

  downloadManifest() {
    const { account } = this.props;

    const url = window.location.origin;
    const backendUrl =
      BaseAPI.baseRequestURL === "/_api/" ? window.location.origin + BaseAPI.baseRequestURL : BaseAPI.baseRequestURL;
    const detailUrl = account?.configuration?.cloud_base_url;

    const fileContent =
      "application: aible {\n" +
      'label: "Aible Looker Extension"\n' +
      'url: "' +
      url +
      '/main.js"\n' +
      "entitlements: {\n" +
      "local_storage: yes\n" +
      "navigation: yes\n" +
      "new_window: yes\n" +
      "new_window_external_urls: []\n" +
      "use_form_submit: yes\n" +
      "use_embeds: yes\n" +
      "use_downloads: yes\n" +
      "core_api_methods: [\n" +
      '"create_user_attribute",\n' +
      '"all_user_attributes",\n' +
      '"update_user_attribute",\n' +
      '"update_dashboard_layout_component",\n' +
      '"dashboard_layout_dashboard_layout_components",\n' +
      '"dashboard_layout",\n' +
      '"update_dashboard_layout",\n' +
      '"dashboard_dashboard_layouts",\n' +
      '"git_branch",\n' +
      '"deploy_ref_to_production",\n' +
      '"deploy_to_production",\n' +
      '"reset_project_to_production",\n' +
      '"reset_project_to_remote",\n' +
      '"update_lookml_model",\n' +
      '"me",\n' +
      '"create_sql_query",\n' +
      '"create_dashboard_element",\n' +
      '"create_query",\n' +
      '"all_dashboards",\n' +
      '"create_dashboard",\n' +
      '"get_dashboard",\n' +
      '"update_dashboard",\n' +
      '"create_project",\n' +
      '"create_lookml_model",\n' +
      '"dashboard_dashboard_elements",\n' +
      '"delete_dashboard_element",\n' +
      '"dashboard",\n' +
      '"workspace",\n' +
      '"all_workspaces",\n' +
      '"create_folder",\n' +
      '"folder",\n' +
      '"search_folders",\n' +
      '"all_looks",\n' +
      "]\n" +
      "external_api_urls: [\n" +
      '"https://api.bitbucket.org",\n' +
      '"https://*.amazonaws.com",\n' +
      '"https://app.launchdarkly.com",\n' +
      '"https://events.launchdarkly.com",\n' +
      '"' +
      url +
      '",\n' +
      '"' +
      backendUrl +
      '",\n' +
      '"' +
      detailUrl +
      '",\n' +
      "]\n" +
      "oauth2_urls: []\n" +
      "scoped_user_attributes: []\n" +
      "global_user_attributes: []\n" +
      "}\n" +
      "}";

    const link = document.createElement("a");

    const file = new Blob([fileContent], { type: "text/plain" });

    link.href = URL.createObjectURL(file);

    link.download = "manifest.txt";

    link.click();
    URL.revokeObjectURL(link.href);
  }

  render() {
    const { account, isCreate, isSelected, handleDelete, onClick, isAzureAccount, noHover, updateLookerURL } =
      this.props;
    const {
      isCreating,
      name,
      accountId,
      showAnnotations,
      createType,
      subscriptionID,
      regionName,
      cloudBaseUrl,
      projectId,
      gcpRegionName,
      lookerURL
    } = this.state;

    if (isCreating) {
      const gcpRegionOptions = [
        { value: "us-west1", label: "Oregon (us-west1)" },
        { value: "us-central1", label: "Iowa (us-central1)" },
        { value: "us-east1", label: "South Carolina (us-east1)" },
        { value: "us-east4", label: "Northern Virginia (us-east4)" },
        { value: "southamerica-east1", label: "São Paulo (southamerica-east1)" },
        { value: "europe-west1", label: "Belgium (europe-west1)" },
        { value: "europe-west2", label: "London (europe-west2)" },
        { value: "asia-southeast1", label: "Singapore (asia-southeast1)" },
        { value: "asia-east1", label: "Taiwan (asia-east1)" }
      ];

      return (
        <div
          className={
            styles.tile +
            " " +
            styles.account +
            (createType === "azure" ? " " + styles.azureAccount : "") +
            (createType === "gcp" ? " " + styles.gcpAccount : "") +
            " " +
            (isCreating === true ? styles.createAcct : "")
          }
          style={isCreating === true ? { justifyContent: "flex-start" } : {}}
        >
          {isCreating === false ? (
            <div className={styles.flex}>
              <FontAwesomeIcon icon={faPlus} style={{ height: "50px", width: "50px", marginRight: "15px" }} />
              {"Link New AWS Account"}
            </div>
          ) : (
            <div className={styles.createForm}>
              <div className={styles.inputHolder}>
                <div className={styles.iLabel}>{"Account Nickname:"}</div>
                <LineInput
                  isBox
                  ref="name"
                  value={name}
                  className={styles.input}
                  updateInstant
                  onChange={(val) => this.setState({ name: val })}
                />
              </div>
              {createType === "aws" ? (
                <div className={styles.inputHolder}>
                  <div className={styles.iLabel}>{"AWS Account ID:"}</div>
                  <LineInput
                    isBox
                    ref="accountId"
                    value={accountId}
                    className={styles.input}
                    updateInstant
                    onChange={(val) => this.setState({ accountId: val })}
                  />
                </div>
              ) : (
                ""
              )}
              {createType === "azure" ? (
                <React.Fragment>
                  <div className={styles.inputHolder}>
                    <div className={styles.iLabel}>{"Azure Subscription ID:"}</div>
                    <LineInput
                      isBox
                      ref="subscriptionID"
                      value={subscriptionID}
                      className={styles.input}
                      updateInstant
                      onChange={(val) => this.setState({ subscriptionID: val })}
                    />
                  </div>
                  {/* <div className={styles.inputHolder}>
                    <div className={styles.iLabel}>{"Azure Cloud Base URL:"}</div>
                    <LineInput
                      isBox
                      ref="cloudBaseUrl"
                      value={cloudBaseUrl}
                      className={styles.input}
                      updateInstant
                      onChange={(val) => this.setState({ cloudBaseUrl: val })}
                    />
                  </div> */}
                  <div className={styles.inputHolder}>
                    <div className={styles.iLabel}>{"Region:"}</div>
                    <div style={{ width: "90%" }}>
                      <Select
                        placeholder={"Select a Region"}
                        menuPlacement="top"
                        options={[
                          { value: "East US", label: "East US" },
                          { value: "Central US", label: "Central US" }
                        ]}
                        value={{ value: regionName, label: regionName }}
                        onChange={({ value }) => this.setState({ regionName: value })}
                      />
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
              {createType === "gcp" ? (
                <React.Fragment>
                  <div className={styles.inputHolder}>
                    <div className={styles.iLabel}>{"GCP Project ID:"}</div>
                    <LineInput
                      isBox
                      ref="projectId"
                      value={projectId}
                      className={styles.input}
                      updateInstant
                      onChange={(val) => this.setState({ projectId: val })}
                    />
                  </div>
                  <div className={styles.inputHolder}>
                    <div className={styles.iLabel}>{"Region:"}</div>
                    <div style={{ width: "90%" }}>
                      <Select
                        placeholder={"Select a Region"}
                        menuPlacement="top"
                        options={gcpRegionOptions}
                        value={gcpRegionOptions?.find((o) => o.value === gcpRegionName)}
                        onChange={({ value }) => this.setState({ gcpRegionName: value })}
                      />
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
              <div className={styles.buttonHolder}>
                {isAzureAccount && isEnabled("azure-account") ? (
                  <AccountTypeDropdown
                    createType={createType}
                    selectHandler={(type) => this.setState({ createType: type })}
                  />
                ) : (
                  ""
                )}
                <div style={{ flexGrow: 1 }} />
                <Button
                  isSmall
                  type="secondary"
                  style={{ marginRight: "10px" }}
                  onClick={() => this.setState({ isCreating: false })}
                >
                  {"Cancel"}
                </Button>
                <Button
                  isSmall
                  type="primary"
                  disabled={
                    name === "" ||
                    (createType === "aws" && accountId === "") ||
                    (createType === "azure" && subscriptionID === "")
                  }
                  onClick={() => {
                    if (createType === "aws") {
                      return this.handleCreate(name, accountId);
                    }
                    if (createType === "azure") {
                      return this.handleAzureCreate(name, subscriptionID, cloudBaseUrl, regionName);
                    }
                    if (createType === "gcp") {
                      return this.handleGCPCreate(name, projectId, gcpRegionName);
                    }
                  }}
                >
                  {"Create"}
                </Button>
              </div>
            </div>
          )}
        </div>
      );
    }

    if (isCreate) {
      return (
        <div
          className={styles.tile + " " + styles.account}
          onClick={() => this.setState({ isCreating: true })}
          style={{ justifyContent: "center" }}
        >
          <div className={styles.newMessage}>{"New Account"}</div>
          <div className={styles.uploadIconMed + " " + styles.accountColor}>
            <FontAwesomeIcon icon={faPlus} />
          </div>
        </div>
      );
    }

    if (account === undefined) {
      return <div />;
    }

    return (
      <div
        className={
          (onClick && account.status === "ACTIVE" ? styles.tile : styles.tileNoHover) +
          " " +
          styles.account +
          " " +
          (noHover ? " " + styles.noHover : "") +
          (isSelected ? styles.accountHighlight : "")
        }
        onClick={onClick && account.status === "ACTIVE" ? () => onClick() : () => {}}
      >
        <div className={styles.topHolder}>
          <div className={styles.icon + " " + styles.aColor}>
            {account.type === "AWS" || account.type === "AZURE" || account.type === "GCP" ? (
              <AccountTypeIcon type={account.type.toLowerCase()} />
            ) : (
              <FontAwesomeIcon icon={faDesktop} />
            )}
          </div>
          <div className={styles.topInfo}>
            <div className={styles.label} title={account.name + " (" + account.id + ")"}>
              {account.name + " (" + account.id + ")"}
            </div>
            <div className={styles.dateHolder}>
              <div
                className={styles.botDate}
                title={moment.utc(account.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment.utc(account.created_date).local().fromNow()}
              </div>
            </div>
          </div>
        </div>
        {handleDelete &&
          account.name &&
          isEnabled("allow-cloud-account-deletion") &&
          account.name.toLowerCase() !== "aible primary aws account" &&
          account.name.toLowerCase() !== "aible sample account" && (
            <div className={styles.actions}>
              <Button
                type="secondary"
                className={styles.smallActionButton}
                title="Delete Account"
                onClick={(event) => {
                  event.stopPropagation();
                  handleDelete(account.id);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
              {/*
            <Button
              type="secondary"
              className={styles.smallActionButton}
              title="Delete Tenant"
              onClick={event => this.handleDelete(event, tenant)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
            */}
            </div>
          )}
        <div className={styles.middleHolder}>
          {isSelected ? <Badge>{"Selected"}</Badge> : ""}
          {!isSelected && !noHover && account.status === "ACTIVE" ? (
            <div className={styles.hideHover}>{"Click to Select Account"}</div>
          ) : (
            ""
          )}
          <div>
            {(account.type === "AZURE" || account.type === "AWS" || account.type === "GCP") &&
            account.status === "PENDING" &&
            account.configuration &&
            account.configuration.setup_url ? (
              <div className={styles.pending}>
                <a href={account.configuration.setup_url} target="_blank">
                  {account.type === "AWS"
                    ? "Click here to complete linking"
                    : "Click here to download setup shell script"}
                </a>
              </div>
            ) : (
              ""
            )}
            {account.type === "GCP" ? (
              <div className={styles.pending}>
                <a onClick={() => this.downloadManifest()}>
                  <div>{"Generate Manifest File"}</div>
                </a>
              </div>
            ) : (
              ""
            )}
            {account.type === "GCP" && isEnabled("tenant-edit-looker-url") ? (
              <div className={styles.pending}>
                <Tooltip
                  trigger={["click"]}
                  overlay={
                    <div className={styles.lookerURL} style={{ maxWidth: "200px", wordBreak: "break-word" }}>
                      {"Enter Looker Instance URL"}
                      <LineInput
                        onChange={(val) => this.setState({ lookerURL: val })}
                        defaultValue={account?.configuration?.looker_export_url}
                      />
                      <div
                        style={{
                          width: "100%",
                          marginTop: "10px",
                          display: "flex",
                          justifyContent: "flex-end"
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            updateLookerURL({
                              id: account.id,
                              lookerURL: lookerURL
                            })
                          }
                          disabled={lookerURL === undefined}
                        >
                          {"Save"}
                        </Button>
                      </div>
                    </div>
                  }
                >
                  <a>
                    <div>
                      {(account?.configuration?.looker_export_url === undefined ? "Add" : "Edit") + " Looker URL"}
                    </div>
                  </a>
                </Tooltip>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {account.annotations && account.annotations.length > 0 ? (
          <div className={styles.corrections}>
            <OverlayTrigger
              placement="top"
              trigger={["click"]}
              rootClose
              overlay={
                <Popover
                  id="popover-positioned-top"
                  title={" Annotation" + (account.annotations.length > 1 ? "s" : "")}
                >
                  <div className={styles.wList}>
                    {account.annotations.map((warning, index) => this.renderMessage(warning, index))}
                  </div>
                  {account?.container?.tag && (
                    <div className={styles.tagHolder}>{`Image Tag: ${account.container.tag}`}</div>
                  )}
                </Popover>
              }
            >
              <div onClick={(event) => event.stopPropagation()} className={styles.infoLine}>
                <div className={styles.warnColor + " " + styles.smallLogo}>
                  <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <a>{account.annotations.length + " Annotation" + (account.annotations.length > 1 ? "s" : "")}</a>
              </div>
            </OverlayTrigger>
          </div>
        ) : (
          <div className={styles.emptyWarnings} />
        )}
        {account.client_secret && (
          <React.Fragment>
            <div className={styles.infoLine}>
              <div className={styles.warnColor + " " + styles.smallLogo}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </div>
              <div className={styles.topInfo}>
                <div
                  className={styles.info}
                  onClick={() => {
                    toast("Client Secret to clipboard.", {
                      type: toast.TYPE.SUCCESS,
                      position: toast.POSITION.TOP_CENTER,
                      autoClose: 5000
                    });
                    navigator.clipboard.writeText(account.client_secret);
                  }}
                >
                  <a>Click to Copy Client Secret</a>
                </div>
              </div>
            </div>
            <div className={styles.infoLine}>
              <div className={styles.warnColor + " " + styles.smallLogo} style={{ visibility: "hidden" }}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </div>
              <div className={styles.topInfo}>
                <div className={styles.info}>This will not be shown again</div>
              </div>
            </div>
          </React.Fragment>
        )}
        <div className={styles.infoLine}>
          <div className={styles.smallLogo}>
            <FontAwesomeIcon icon={faExclamationCircle} />
          </div>
          <div className={styles.topInfo}>
            <div className={styles.info} title={account.status}>
              {account.status ? account.status.toLowerCase() : ""}
            </div>
          </div>
        </div>
        <div className={styles.infoLine}>
          <div className={styles.smallLogo}>
            <FontAwesomeIcon icon={faUser} />
          </div>
          <div className={styles.topInfo}>
            <div className={styles.info} title={account && account.created_by ? account.created_by.fullname : ""}>
              {account && account.created_by ? account.created_by.fullname : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class AccountTypeIcon extends React.PureComponent {
  render() {
    const { type, hide } = this.props;
    let iconSrc = awsIcon;
    if (type === "azure") {
      iconSrc = azureIcon;
    }
    if (type === "gcp") {
      iconSrc = gcpIcon;
    }
    return (
      <div className={styles.accountTypeIcon + (hide ? " " + styles.accountTypeIconHide : "")}>
        <img src={iconSrc} alt={type} />
      </div>
    );
  }
}

export class AccountTypeDropdown extends React.Component {
  state = {
    show: false
  };
  render() {
    const { createType, selectHandler } = this.props;
    const { show } = this.state;
    return (
      <div className={styles.accountTypeSelectWrapper}>
        <div className={styles.accountTypeSelect} onClick={() => this.setState({ show: !show })}>
          <AccountTypeIcon type={createType} />
          <p>{"▾"}</p>
        </div>
        <div className={styles.accountTypeSelectItems + (show ? "" : " " + styles.accountTypeSelectHide)}>
          <div
            className={styles.accountTypeSelectItem}
            onClick={() => {
              selectHandler("gcp");
              this.setState({ show: false });
            }}
          >
            <AccountTypeIcon type={"gcp"} />
            <p>GCP</p>
          </div>
          <div
            className={styles.accountTypeSelectItem}
            onClick={() => {
              selectHandler("azure");
              this.setState({ show: false });
            }}
          >
            <AccountTypeIcon type={"azure"} />
            <p>Azure</p>
          </div>
          <div
            className={styles.accountTypeSelectItem}
            onClick={() => {
              selectHandler("aws");
              this.setState({ show: false });
            }}
          >
            <AccountTypeIcon type={"aws"} />
            <p>AWS</p>
          </div>
        </div>
      </div>
    );
  }
}
